/* =========================================================
   REBUY - GIFT POUCH (AUTO-ADD IN CART)
   - Adds pouch automatically when there is at least 1 paid item
   - Keeps pouch qty forced to 1 (anti double click / race)
   - Hides qty controls + remove button for pouch in SmartCart UI
   - Blocks checkout if cart total is 0 (prevents gift-only checkout)
========================================================= */

/* =========================
   CONFIG
========================= */

const GIFT_PRODUCT_ID = 8894345380083;      // pouch product_id
const GIFT_VARIANT_ID = 46151278428403;     // pouch variant_id
const GIFT_IMAGE_URL  = 'https://cdn.shopify.com/s/files/1/0657/7170/0467/files/Pouch_Brown_new.png?v=1772030734';

const GIFT_HEADER_TEXT = 'FREE POUCH + FREE SHIPPING ON ALL ORDERS';
const GIFT_NOTE_TEXT   = '* Free pouch is automatically included with every purchase.';

const REBUY_CHECKOUT_BTN_SELECTOR = '.rebuy-cart__flyout-actions .rebuy-cart__checkout-button';


/* =========================
   HELPERS
========================= */

function sleep(ms){ return new Promise(r => setTimeout(r, ms)); }

async function fetchCart(){
  const r = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
  return r.json();
}

function cartHasPaidProduct(items){
  if (!items || !items.length) return false;
  return items.some(i => Number(i.product_id) !== Number(GIFT_PRODUCT_ID));
}

function findGiftItem(items){
  if (!items || !items.length) return null;
  return items.find(i => Number(i.product_id) === Number(GIFT_PRODUCT_ID)) || null;
}

async function addGiftVariant(){
  const body = new URLSearchParams();
  body.append('id', String(GIFT_VARIANT_ID));
  body.append('quantity', '1');
  body.append('properties[Gift]', 'Free pouch');

  const r = await fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    body
  });

  let data = null;
  try { data = await r.json(); } catch(e) {}
  if (!r.ok) throw new Error('addGiftVariant failed: ' + (data && data.description ? data.description : r.status));
  return data;
}

async function setVariantQty(variantId, qty){
  const payload = { updates: {} };
  payload.updates[String(variantId)] = qty;

  const r = await fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  const data = await r.json();
  if (!r.ok) throw new Error('setVariantQty failed: ' + r.status);
  return data;
}

async function removeVariant(variantId){
  return setVariantQty(variantId, 0);
}


/* =========================
   UI: STATIC BANNER
========================= */

function renderGiftMessage(){
  const $container = jQuery('.rebuy-cart__flyout-content');
  if (!$container.length) return;
  if ($container.find('.gift-message').length) return;

  const imgHtml = GIFT_IMAGE_URL
    ? '<img src="' + GIFT_IMAGE_URL + '" alt="Free Pouch" style="max-width:120px;margin:8px auto;display:block;" />'
    : '';

  $container.prepend(
    '<div class="gift-message" style="padding:16px;border-bottom:1px solid #eee;text-align:center;">' +
      '<p style="font-weight:600;margin:0 0 8px 0;">' + GIFT_HEADER_TEXT + '</p>' +
      imgHtml +
      '<p style="font-size:12px;opacity:.7;margin:8px 0 0 0;">' + GIFT_NOTE_TEXT + '</p>' +
    '</div>'
  );
}

function showCheckoutBlockedMessage(){
  const $container = jQuery('.rebuy-cart__flyout-content');
  if (!$container.length) return;

  if ($container.find('.gift-checkout-blocked').length) return;

  $container.prepend(
    '<div class="gift-checkout-blocked" style="padding:12px 16px;background:#fff4f4;border-bottom:1px solid #ffd2d2;text-align:center;">' +
      '<p style="margin:0;font-size:13px;">Your cart total is $0. Please add at least one product to checkout.</p>' +
    '</div>'
  );

  setTimeout(function(){
    $container.find('.gift-checkout-blocked').fadeOut(200, function(){ jQuery(this).remove(); });
  }, 3500);
}


/* =========================
   UI LOCK: hide qty + remove for gift line
========================= */

function lockGiftQuantityControls(){
  const $giftLine = jQuery('.rebuy-cart__flyout-content')
    .find('[data-variant-id="' + GIFT_VARIANT_ID + '"]');

  if (!$giftLine.length) return;

  // Hide qty controls + remove (names may vary across themes/Rebuy versions, so we hide both common ones)
  $giftLine.find('.cart--quantity--container, .rebuy-cart__line-item-quantity').hide();
  $giftLine.find('.cart--item--remove, .rebuy-cart__line-item-remove').hide();

  // Optional "Gift" label
  if ($giftLine.find('.gift-label').length === 0) {
    $giftLine.find('.cart--item--title, .rebuy-cart__line-item-title').first().append(
      '<div class="gift-label" style="font-size:12px;opacity:.6;margin-top:4px;">Gift</div>'
    );
  }
}


/* =========================
   CORE LOGIC: keep cart consistent
========================= */

let runningGuard = false;

async function enforceGiftRules(cartFromEvent){
  if (runningGuard) return; // avoid loops
  runningGuard = true;

  try{
    const cart = cartFromEvent && cartFromEvent.items ? cartFromEvent : await fetchCart();

    const hasPaid = cartHasPaidProduct(cart.items);
    const giftItem = findGiftItem(cart.items);

    // 1) If no paid product: remove gift (prevents $0 cart)
    if (!hasPaid){
      if (giftItem){
        await removeVariant(GIFT_VARIANT_ID);
        await sleep(200);
      }
      return;
    }

    // 2) If paid products: ensure gift exists and qty=1
    if (!giftItem){
      await addGiftVariant();
      await sleep(250);
    } else if (giftItem.quantity > 1){
      await setVariantQty(GIFT_VARIANT_ID, 1);
      await sleep(200);
    }

  } catch(err){
    console.error('[Gift Pouch] enforceGiftRules error:', err);
  } finally {
    runningGuard = false;
  }
}


/* =========================
   CHECKOUT BLOCK (if total is 0)
========================= */

let checkoutLock = false;

async function handleCheckoutClick(e){
  const target = e.target;
  if (!target || !target.closest) return;

  const btn = target.closest(REBUY_CHECKOUT_BTN_SELECTOR);
  if (!btn) return;

  if (checkoutLock){
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  checkoutLock = true;

  try{
    const cart = await fetchCart();

    // If cart total is 0 => block checkout
    if (!cart || Number(cart.total_price) <= 0){
      e.preventDefault();
      e.stopPropagation();
      showCheckoutBlockedMessage();
      checkoutLock = false;
      return;
    }

    // Also ensure gift rules right before checkout (safety)
    await enforceGiftRules(cart);

    // Allow normal navigation to continue (do not redirect manually)
    checkoutLock = false;

  } catch(err){
    console.error('[Gift Pouch] checkout guard error:', err);
    // Fail open: allow checkout
    checkoutLock = false;
  }
}


/* =========================
   PRODUCT PAGE FIX (if your theme uses it)
========================= */

function restoreAddToCart(){
  jQuery('body.template--product button.product-form--add-to-cart').css('pointer-events','auto');
  jQuery('body.template--product span.product-form--spinner').hide();
  jQuery('body.template--product span.product-form--text').show();
}


/* =========================
   HOOKS
========================= */

// Capture-phase click handler keeps working even if Rebuy re-renders the button
if (!window.__LS_GIFT_POUCH_CHECKOUT_GUARD__){
  document.addEventListener('click', handleCheckoutClick, true);
  window.__LS_GIFT_POUCH_CHECKOUT_GUARD__ = true;
}

document.addEventListener('rebuy:smartcart.ready', function(event){
  renderGiftMessage();

  const cart = event && event.detail && event.detail.smartcart && event.detail.smartcart.cart
    ? event.detail.smartcart.cart
    : null;

  enforceGiftRules(cart);
  // UI lock after a tiny delay to let Rebuy paint line items
  setTimeout(lockGiftQuantityControls, 250);

  restoreAddToCart();
});

document.addEventListener('rebuy:cart.change', function(event){
  renderGiftMessage();

  const cart = event && event.detail && event.detail.cart && event.detail.cart.cart
    ? event.detail.cart.cart
    : null;

  enforceGiftRules(cart);
  setTimeout(lockGiftQuantityControls, 200);
});